import React from 'react';

var View = React.createClass({
    render: function () {
        return (
            <div className="footer">
                <p>Copyright © 2016-2020 www.yuanying.com All Rights Reserved 版权所有·远影医疗</p>
                <p>京ICP证140186号 | 网络文化经营许可证京网文[2013]0918-967号 | 京ICP备案编号12049600-1 | 京公网安备11011202001441号 | 营业执照</p>
            </div>
        )
    }
});

export default View;


// WEBPACK FOOTER //
// ./components/common/footer.jsx